import { render } from "./ContactPage.vue?vue&type=template&id=50f1a2f8&scoped=true"
import script from "./ContactPage.vue?vue&type=script&lang=js"
export * from "./ContactPage.vue?vue&type=script&lang=js"

import "./ContactPage.vue?vue&type=style&index=0&id=50f1a2f8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-50f1a2f8"

export default script